var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    staticClass: "inputcheck",
    attrs: {
      "type": "checkbox",
      "id": "check4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check4"
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.inbound')))]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveConfigInbound()
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.inbound')) + " : " + _vm._s(_vm.$t('sla.drclose')) + " - " + _vm._s(_vm.$t('sla.drcreation')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.tattype')) + " : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundTatTypeRadioButton),
      expression: "inboundTatTypeRadioButton"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableFixedDuration",
      "name": "inboundType",
      "value": "fixedDuration"
    },
    domProps: {
      "checked": _vm.inboundTatTypeRadioButton == 'fixedDuration',
      "checked": _vm._q(_vm.inboundTatTypeRadioButton, "fixedDuration")
    },
    on: {
      "click": function($event) {
        _vm.onClickMakitNull('inboundFix')
      },
      "__c": function($event) {
        _vm.inboundTatTypeRadioButton = "fixedDuration"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableFixedDuration"
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.fixeduration')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundTatTypeRadioButton),
      expression: "inboundTatTypeRadioButton"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableCutoffBased",
      "name": "inboundType",
      "value": "cutoff"
    },
    domProps: {
      "checked": _vm.inboundTatTypeRadioButton == 'cutoff',
      "checked": _vm._q(_vm.inboundTatTypeRadioButton, "cutoff")
    },
    on: {
      "change": _vm.transitFixedDurAndCutoffBased,
      "__c": function($event) {
        _vm.inboundTatTypeRadioButton = "cutoff"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableCutoffBased"
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.cutoffbased')))])])]), _vm._v(" "), (_vm.inboundTatTypeRadioButton == 'fixedDuration') ? _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundtathrs),
      expression: "inboundtathrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true }"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.inboundtathrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "inboundtathrs",
      "name": "inboundtathrs",
      "min": "0",
      "max": "167",
      "data-vv-scope": "tab1",
      "required": ""
    },
    domProps: {
      "value": (_vm.inboundtathrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundtathrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundtatmin),
      expression: "inboundtatmin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true }"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.inboundtatmin')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "inboundtatmin",
      "name": "inboundtatmin",
      "min": "0",
      "max": "59",
      "data-vv-scope": "tab1"
    },
    domProps: {
      "value": (_vm.inboundtatmin)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundtatmin = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.thresholdbreach')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundthresholdhrs),
      expression: "inboundthresholdhrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true }"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.inboundthresholdhrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "inboundthresholdhrs",
      "min": "0",
      "max": "167",
      "name": "inboundthresholdhrs",
      "data-vv-scope": "tab1"
    },
    domProps: {
      "value": (_vm.inboundthresholdhrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundthresholdhrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundthresholdmin),
      expression: "inboundthresholdmin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true }"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab1.inboundthresholdmin')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "inboundthresholdmin",
      "min": "0",
      "max": "59",
      "name": "inboundthresholdmin",
      "data-vv-scope": "tab1"
    },
    domProps: {
      "value": (_vm.inboundthresholdmin)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundthresholdmin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.inboundthresholdErr),
      callback: function($$v) {
        _vm.inboundthresholdErr = $$v
      },
      expression: "inboundthresholdErr"
    }
  }, [_vm._v(_vm._s(this.inboundthresholdErr))])])]) : _vm._e(), _vm._v(" "), (_vm.inboundTatTypeRadioButton == 'cutoff') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row col-lg-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.drcreationcutoff'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.drCreationCutoff.day),
      expression: "drCreationCutoff.day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab5.drCreationCutoff.day')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "id": "drCreationCutoff.day",
      "min": "1",
      "max": "7",
      "name": "drCreationCutoff.day",
      "data-vv-scope": "tab5",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.drCreationCutoff.day)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.drCreationCutoff.day = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.drCreationCutoff.hrs),
      expression: "drCreationCutoff.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab5.drCreationCutoff.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "drCreationCutoff.hrs",
      "min": "0",
      "max": "23",
      "name": "drCreationCutoff.hrs",
      "data-vv-scope": "tab5"
    },
    domProps: {
      "value": (_vm.drCreationCutoff.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.drCreationCutoff.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.drCreationCutoff.min),
      expression: "drCreationCutoff.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab5.drCreationCutoff.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "drCreationCutoff.min",
      "min": "0",
      "max": "59",
      "name": "drCreationCutoff.min",
      "data-vv-scope": "tab5"
    },
    domProps: {
      "value": (_vm.drCreationCutoff.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.drCreationCutoff.min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.inboundsla'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundSla.day),
      expression: "inboundSla.day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab5.inboundSla.day')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "id": "inboundSla.day",
      "min": "1",
      "max": "7",
      "name": "inboundSla.day",
      "data-vv-scope": "tab5"
    },
    domProps: {
      "value": (_vm.inboundSla.day)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundSla.day = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundSla.hrs),
      expression: "inboundSla.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab5.inboundSla.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "inboundSla.hrs",
      "min": "0",
      "max": "23",
      "name": "inboundSla.hrs",
      "data-vv-scope": "tab5"
    },
    domProps: {
      "value": (_vm.inboundSla.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundSla.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundSla.min),
      expression: "inboundSla.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab5.inboundSla.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "inboundSla.min",
      "min": "0",
      "max": "59",
      "name": "inboundSla.min",
      "data-vv-scope": "tab5"
    },
    domProps: {
      "value": (_vm.inboundSla.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundSla.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.inboundSla.err),
      callback: function($$v) {
        _vm.inboundSla.err = $$v
      },
      expression: "inboundSla.err"
    }
  }, [_vm._v(_vm._s(this.inboundSla.err))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "margin-left": "13px"
    }
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.thresholdbreach')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundThreshold.hrs),
      expression: "inboundThreshold.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab5.inboundThreshold.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "inboundThreshold.hrs",
      "min": "0",
      "max": "167",
      "name": "inboundThreshold.hrs",
      "data-vv-scope": "tab5"
    },
    domProps: {
      "value": (_vm.inboundThreshold.hrs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundThreshold.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inboundThreshold.min),
      expression: "inboundThreshold.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab5.inboundThreshold.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "inboundThreshold.min",
      "min": "0",
      "max": "59",
      "name": "inboundThreshold.min",
      "data-vv-scope": "tab5"
    },
    domProps: {
      "value": (_vm.inboundThreshold.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inboundThreshold.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.inboundThreshold.err),
      callback: function($$v) {
        _vm.inboundThreshold.err = $$v
      },
      expression: "inboundThreshold.err"
    }
  }, [_vm._v(_vm._s(this.inboundThreshold.err))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetConfigInbound()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.resetBtn')))])])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    staticClass: "inputcheck",
    attrs: {
      "required": "",
      "type": "checkbox",
      "id": "check5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check5"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.outbound')))]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveConfigOutbound()
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.outboundtat')) + " : " + _vm._s(_vm.$t('sla.orderdispatch')) + " - " + _vm._s(_vm.$t('sla.ordercreation')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.tattype')) + " : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundTatTypeRadioButton),
      expression: "outboundTatTypeRadioButton"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableFixedDuration",
      "name": "outboundType",
      "value": "fixedDuration"
    },
    domProps: {
      "checked": _vm.outboundTatTypeRadioButton == 'fixedDuration',
      "checked": _vm._q(_vm.outboundTatTypeRadioButton, "fixedDuration")
    },
    on: {
      "__c": function($event) {
        _vm.outboundTatTypeRadioButton = "fixedDuration"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableFixedDuration"
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.fixeduration')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundTatTypeRadioButton),
      expression: "outboundTatTypeRadioButton"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableCutoffBased",
      "name": "outboundType",
      "value": "cutoff"
    },
    domProps: {
      "checked": _vm.outboundTatTypeRadioButton == 'cutoff',
      "checked": _vm._q(_vm.outboundTatTypeRadioButton, "cutoff")
    },
    on: {
      "change": _vm.transitFixedDurAndCutoffBased,
      "__c": function($event) {
        _vm.outboundTatTypeRadioButton = "cutoff"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableCutoffBased"
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.cutoffbased')))])])]), _vm._v(" "), (_vm.outboundTatTypeRadioButton == 'fixedDuration') ? _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundFixedDuration.hrs),
      expression: "outboundFixedDuration.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab2.outboundFixedDuration.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "outboundFixedDuration.hrs",
      "min": "0",
      "max": "167",
      "name": "outboundFixedDuration.hrs",
      "data-vv-scope": "tab2"
    },
    domProps: {
      "value": (_vm.outboundFixedDuration.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundFixedDuration.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundFixedDuration.min),
      expression: "outboundFixedDuration.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab2.outboundFixedDuration.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "outboundFixedDuration.min",
      "min": "0",
      "max": "59",
      "name": "outboundFixedDuration.min",
      "data-vv-scope": "tab2"
    },
    domProps: {
      "value": (_vm.outboundFixedDuration.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundFixedDuration.min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.thresholdbreach')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundFixedDurationThreshold.hrs),
      expression: "outboundFixedDurationThreshold.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab2.outboundFixedDurationThreshold.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "outboundFixedDurationThreshold.hrs",
      "min": "0",
      "max": "167",
      "name": "outboundFixedDurationThreshold.hrs",
      "data-vv-scope": "tab2"
    },
    domProps: {
      "value": (_vm.outboundFixedDurationThreshold.hrs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundFixedDurationThreshold.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundFixedDurationThreshold.min),
      expression: "outboundFixedDurationThreshold.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab2.outboundFixedDurationThreshold.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "outboundFixedDurationThreshold.min",
      "min": "0",
      "max": "59",
      "name": "outboundFixedDurationThreshold.min",
      "data-vv-scope": "tab2"
    },
    domProps: {
      "value": (_vm.outboundFixedDurationThreshold.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundFixedDurationThreshold.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.outboundFixedDurationThreshold.hrMinErr),
      callback: function($$v) {
        _vm.outboundFixedDurationThreshold.hrMinErr = $$v
      },
      expression: "outboundFixedDurationThreshold.hrMinErr"
    }
  }, [_vm._v("\n                        " + _vm._s(this.outboundFixedDurationThreshold.hrMinErr))])])]) : _vm._e(), _vm._v(" "), (_vm.outboundTatTypeRadioButton == 'cutoff') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row col-lg-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.ordercreationcutoff'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCreationCutoff.day),
      expression: "orderCreationCutoff.day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab4.orderCreationCutoff.day')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "id": "orderCreationCutoff.day",
      "min": "1",
      "max": "7",
      "name": "orderCreationCutoff.day",
      "data-vv-scope": "tab4",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.orderCreationCutoff.day)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderCreationCutoff.day = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCreationCutoff.hrs),
      expression: "orderCreationCutoff.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab4.orderCreationCutoff.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "orderCreationCutoff.hrs",
      "min": "0",
      "max": "23",
      "name": "orderCreationCutoff.hrs",
      "data-vv-scope": "tab4"
    },
    domProps: {
      "value": (_vm.orderCreationCutoff.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderCreationCutoff.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCreationCutoff.min),
      expression: "orderCreationCutoff.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab4.orderCreationCutoff.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "orderCreationCutoff.min",
      "min": "0",
      "max": "59",
      "name": "orderCreationCutoff.min",
      "data-vv-scope": "tab4"
    },
    domProps: {
      "value": (_vm.orderCreationCutoff.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderCreationCutoff.min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.outboundsla'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundSla.day),
      expression: "outboundSla.day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab4.outboundSla.day')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "id": "outboundSla.day",
      "min": "1",
      "max": "7",
      "name": "outboundSla.day",
      "data-vv-scope": "tab4"
    },
    domProps: {
      "value": (_vm.outboundSla.day)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundSla.day = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundSla.hrs),
      expression: "outboundSla.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab4.outboundSla.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "outboundSla.hrs",
      "min": "0",
      "max": "23",
      "name": "outboundSla.hrs",
      "data-vv-scope": "tab4"
    },
    domProps: {
      "value": (_vm.outboundSla.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundSla.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundSla.min),
      expression: "outboundSla.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab4.outboundSla.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "outboundSla.min",
      "min": "0",
      "max": "59",
      "name": "outboundSla.min",
      "data-vv-scope": "tab4"
    },
    domProps: {
      "value": (_vm.outboundSla.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundSla.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.outboundSla.err),
      callback: function($$v) {
        _vm.outboundSla.err = $$v
      },
      expression: "outboundSla.err"
    }
  }, [_vm._v(_vm._s(this.outboundSla.err))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "margin-left": "13px"
    }
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.thresholdbreach')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundThreshold.hrs),
      expression: "outboundThreshold.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab4.outboundThreshold.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "outboundThreshold.hrs",
      "min": "0",
      "max": "167",
      "name": "outboundThreshold.hrs",
      "data-vv-scope": "tab4"
    },
    domProps: {
      "value": (_vm.outboundThreshold.hrs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundThreshold.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.outboundThreshold.min),
      expression: "outboundThreshold.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab4.outboundThreshold.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "outboundThreshold.min",
      "min": "0",
      "max": "59",
      "name": "outboundThreshold.min",
      "data-vv-scope": "tab4"
    },
    domProps: {
      "value": (_vm.outboundThreshold.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.outboundThreshold.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.outboundThreshold.err),
      callback: function($$v) {
        _vm.outboundThreshold.err = $$v
      },
      expression: "outboundThreshold.err"
    }
  }, [_vm._v(_vm._s(this.outboundThreshold.err))])])]) : _vm._e(), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetConfigOutbound()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.resetBtn')))])])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[6]),
      expression: "accordianTab[6]"
    }],
    staticClass: "inputcheck",
    attrs: {
      "type": "checkbox",
      "id": "check6"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[6]) ? _vm._i(_vm.accordianTab[6], null) > -1 : (_vm.accordianTab[6])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(6)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[6],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[6] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[6] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 6, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "check6"
    }
  }, [_vm._v(_vm._s(_vm.$t('config.returns')))]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveConfigReturns()
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('b-card', {
    staticClass: "col-lg-12",
    staticStyle: {
      "line-height": "1.7"
    }
  }, [_c('div', {
    staticClass: "row col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.returnstat')) + " : " + _vm._s(_vm.$t('sla.returnsputaway')) + " - " + _vm._s(_vm.$t('sla.returnswhinscan')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.tattype')) + " : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsTatTypeRadioButton),
      expression: "returnsTatTypeRadioButton"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableFixedDuration",
      "name": "returnsType",
      "value": "fixedDuration"
    },
    domProps: {
      "checked": _vm.returnsTatTypeRadioButton == 'fixedDuration',
      "checked": _vm._q(_vm.returnsTatTypeRadioButton, "fixedDuration")
    },
    on: {
      "__c": function($event) {
        _vm.returnsTatTypeRadioButton = "fixedDuration"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableFixedDuration"
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.fixeduration')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsTatTypeRadioButton),
      expression: "returnsTatTypeRadioButton"
    }],
    staticClass: "col-lg-1",
    attrs: {
      "type": "radio",
      "id": "enableCutoffBased",
      "name": "returnsType",
      "value": "cutoff"
    },
    domProps: {
      "checked": _vm.returnsTatTypeRadioButton == 'cutoff',
      "checked": _vm._q(_vm.returnsTatTypeRadioButton, "cutoff")
    },
    on: {
      "change": _vm.transitFixedDurAndCutoffBased,
      "__c": function($event) {
        _vm.returnsTatTypeRadioButton = "cutoff"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enableCutoffBased"
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.cutoffbased')))])])]), _vm._v(" "), (_vm.returnsTatTypeRadioButton == 'fixedDuration') ? _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.b2creturns')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.btocReturns.hrs),
      expression: "btocReturns.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab3.btocReturns.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "btocReturns.hrs",
      "name": "btocReturns.hrs",
      "min": "0",
      "max": "167",
      "data-vv-scope": "tab3"
    },
    domProps: {
      "value": (_vm.btocReturns.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.btocReturns.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.btocReturns.min),
      expression: "btocReturns.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab3.btocReturns.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "btocReturns.min",
      "min": "0",
      "max": "59",
      "name": "btocReturns.min",
      "data-vv-scope": "tab3"
    },
    domProps: {
      "value": (_vm.btocReturns.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.btocReturns.min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.thresholdbreach')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.btocReturnsThreshold.hrs),
      expression: "btocReturnsThreshold.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab3.btocReturnsThreshold.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "btocReturnsThreshold.hrs",
      "min": "0",
      "max": "167",
      "name": "btocReturnsThreshold.hrs",
      "data-vv-scope": "tab3"
    },
    domProps: {
      "value": (_vm.btocReturnsThreshold.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.btocReturnsThreshold.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.btocReturnsThreshold.min),
      expression: "btocReturnsThreshold.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab3.btocReturnsThreshold.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "btocReturnsThreshold.min",
      "min": "0",
      "max": "59",
      "name": "btocReturnsThreshold.min",
      "data-vv-scope": "tab3"
    },
    domProps: {
      "value": (_vm.btocReturnsThreshold.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.btocReturnsThreshold.min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.b2breturns')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.btobReturns.hrs),
      expression: "btobReturns.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab3.btobReturns.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "btobReturns.hrs",
      "min": "0",
      "max": "167",
      "name": "btobReturns.hrs",
      "data-vv-scope": "tab3"
    },
    domProps: {
      "value": (_vm.btobReturns.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.btobReturns.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.btobReturns.min),
      expression: "btobReturns.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab3.btobReturns.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "btobReturns.min",
      "min": "0",
      "max": "59",
      "name": "btobReturns.min",
      "data-vv-scope": "tab3"
    },
    domProps: {
      "value": (_vm.btobReturns.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.btobReturns.min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.thresholdbreach')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.btobReturnsThreshold.hrs),
      expression: "btobReturnsThreshold.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab3.btobReturnsThreshold.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "btobReturnsThreshold.hrs",
      "min": "0",
      "max": "167",
      "name": "btobReturnsThreshold.hrs",
      "data-vv-scope": "tab3"
    },
    domProps: {
      "value": (_vm.btobReturnsThreshold.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.btobReturnsThreshold.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.btobReturnsThreshold.min),
      expression: "btobReturnsThreshold.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab3.btobReturnsThreshold.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "btobReturnsThreshold.min",
      "min": "0",
      "max": "59",
      "name": "btobReturnsThreshold.min",
      "data-vv-scope": "tab3"
    },
    domProps: {
      "value": (_vm.btobReturnsThreshold.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.btobReturnsThreshold.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (this.btocReturns.hrminErr),
      callback: function($$v) {
        this.btocReturns.hrminErr = $$v
      },
      expression: "this.btocReturns.hrminErr"
    }
  }, [_vm._v(_vm._s(this.btocReturns.hrminErr))])])]) : _vm._e(), _vm._v(" "), (_vm.returnsTatTypeRadioButton == 'cutoff') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row col-lg-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.returnsB2Ccreationcutoff'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2cCreationCutoff.day),
      expression: "returnsb2cCreationCutoff.day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2cCreationCutoff.day')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "id": "returnsb2cCreationCutoff.day",
      "min": "1",
      "max": "7",
      "name": "returnsb2cCreationCutoff.day",
      "data-vv-scope": "tab6",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.returnsb2cCreationCutoff.day)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2cCreationCutoff.day = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2cCreationCutoff.hrs),
      expression: "returnsb2cCreationCutoff.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2cCreationCutoff.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "returnsb2cCreationCutoff.hrs",
      "min": "0",
      "max": "23",
      "name": "returnsb2cCreationCutoff.hrs",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2cCreationCutoff.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2cCreationCutoff.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2cCreationCutoff.min),
      expression: "returnsb2cCreationCutoff.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2cCreationCutoff.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "returnsb2cCreationCutoff.min",
      "min": "0",
      "max": "59",
      "name": "returnsb2cCreationCutoff.min",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2cCreationCutoff.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2cCreationCutoff.min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.returnsb2csla'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2cSla.day),
      expression: "returnsb2cSla.day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2cSla.day')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "id": "returnsb2cSla.day",
      "min": "1",
      "max": "7",
      "name": "returnsb2cSla.day",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2cSla.day)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2cSla.day = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2cSla.hrs),
      expression: "returnsb2cSla.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2cSla.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "returnsb2cSla.hrs",
      "min": "0",
      "max": "23",
      "name": "returnsb2cSla.hrs",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2cSla.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2cSla.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2cSla.min),
      expression: "returnsb2cSla.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2cSla.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "returnsb2cSla.min",
      "min": "0",
      "max": "59",
      "name": "returnsb2cSla.min",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2cSla.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2cSla.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.returnsb2cSla.err),
      callback: function($$v) {
        _vm.returnsb2cSla.err = $$v
      },
      expression: "returnsb2cSla.err"
    }
  }, [_vm._v(_vm._s(this.returnsb2cSla.err))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "margin-left": "13px"
    }
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.thresholdbreach')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2cThreshold.hrs),
      expression: "returnsb2cThreshold.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2cThreshold.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "returnsb2cThreshold.hrs",
      "min": "0",
      "max": "167",
      "name": "returnsb2cThreshold.hrs",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2cThreshold.hrs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2cThreshold.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2cThreshold.min),
      expression: "returnsb2cThreshold.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2cThreshold.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "returnsb2cThreshold.min",
      "min": "0",
      "max": "59",
      "name": "returnsb2cThreshold.min",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2cThreshold.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2cThreshold.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.returnsb2cThreshold.err),
      callback: function($$v) {
        _vm.returnsb2cThreshold.err = $$v
      },
      expression: "returnsb2cThreshold.err"
    }
  }, [_vm._v(_vm._s(this.returnsb2cThreshold.err))])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12 mt-3",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.returnsB2Bcreationcutoff'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2bCreationCutoff.day),
      expression: "returnsb2bCreationCutoff.day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2bCreationCutoff.day')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "id": "returnsb2bCreationCutoff.day",
      "min": "1",
      "max": "7",
      "name": "returnsb2bCreationCutoff.day",
      "data-vv-scope": "tab6",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.returnsb2bCreationCutoff.day)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2bCreationCutoff.day = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2bCreationCutoff.hrs),
      expression: "returnsb2bCreationCutoff.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2bCreationCutoff.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "returnsb2bCreationCutoff.hrs",
      "min": "0",
      "max": "23",
      "name": "returnsb2bCreationCutoff.hrs",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2bCreationCutoff.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2bCreationCutoff.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2bCreationCutoff.min),
      expression: "returnsb2bCreationCutoff.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2bCreationCutoff.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "returnsb2bCreationCutoff.min",
      "min": "0",
      "max": "59",
      "name": "returnsb2bCreationCutoff.min",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2bCreationCutoff.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2bCreationCutoff.min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.returnsb2bsla'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2bSla.day),
      expression: "returnsb2bSla.day"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2bSla.day')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.day'),
      "id": "returnsb2bSla.day",
      "min": "1",
      "max": "7",
      "name": "returnsb2bSla.day",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2bSla.day)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2bSla.day = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2bSla.hrs),
      expression: "returnsb2bSla.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2bSla.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "returnsb2bSla.hrs",
      "min": "0",
      "max": "23",
      "name": "returnsb2bSla.hrs",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2bSla.hrs)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2bSla.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2bSla.min),
      expression: "returnsb2bSla.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2bSla.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "returnsb2bSla.min",
      "min": "0",
      "max": "59",
      "name": "returnsb2cSla.min",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2bSla.min)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber1($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2bSla.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.returnsb2bSla.err),
      callback: function($$v) {
        _vm.returnsb2bSla.err = $$v
      },
      expression: "returnsb2bSla.err"
    }
  }, [_vm._v(_vm._s(this.returnsb2bSla.err))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "margin-left": "13px"
    }
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.thresholdbreach')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('sla.duration'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2bThreshold.hrs),
      expression: "returnsb2bThreshold.hrs"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2bThreshold.hrs')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.hrs'),
      "id": "returnsb2bThreshold.hrs",
      "min": "0",
      "max": "167",
      "name": "returnsb2bThreshold.hrs",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2bThreshold.hrs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2bThreshold.hrs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.returnsb2bThreshold.min),
      expression: "returnsb2bThreshold.min"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tab6.returnsb2bThreshold.min')
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "required": "",
      "type": "number",
      "placeholder": _vm.$t('sla.mins'),
      "id": "returnsb2bThreshold.min",
      "min": "0",
      "max": "59",
      "name": "returnsb2bThreshold.min",
      "data-vv-scope": "tab6"
    },
    domProps: {
      "value": (_vm.returnsb2bThreshold.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.returnsb2bThreshold.min = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-danger",
    model: {
      value: (_vm.returnsb2bThreshold.err),
      callback: function($$v) {
        _vm.returnsb2bThreshold.err = $$v
      },
      expression: "returnsb2bThreshold.err"
    }
  }, [_vm._v(_vm._s(this.returnsb2bThreshold.err))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "135px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetConfigReturns()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.resetBtn')))])])])], 1)], 1)])])])])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2431b4db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2431b4db","hasScoped":true}!./src/views/components/SLA/slaglobal/slaglobal.component.html
// module id = 2140
// module chunks = 0